export default {
  groups(state) {
    return state.groups;
  },
};
